export const EXPENSE_CATEGORIES = [
  "Struja",
  "Gorivo",
  "Usluge pošte",
  "Špediterske usluge",
  "Potrošni materijal za kancelariju",
  "Potrošni materijal za pakovanje robe",
  "Potrošni materijal za proizvodnju",
  "Alat",
  "Održavanje vozila",
  "Održavanje mašina i alata",
  "Usluge plastifikacije",
  "Usluge vodenog rezanja i lasera",
  "Tokarske usluge",
  "Usluge sječenja/savijanja",
  "Transport",
  "Marketing BiH",
  "Marketing INO",
  "Reprezentacija",
  "Oprema",
  "Servisi",
  "Carinsko posredovanje",
  "Osiguranje",
  "Registracija vozila",
  "Ostalo",
];

export const INVOICE_STATUS = ["Neplaćeno", "Djelimično", "Plaćeno"];

export function curMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}
